import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { AppLayout } from '@/components/AppLayout'
import { isAuthenticated } from '@/lib/auth-store'

export const Route = createFileRoute('/widgets')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/login' })
    }
  },
  component: WidgetsLayout,
})

function WidgetsLayout() {
  return (
    <AppLayout title="Widgets">
      <Outlet />
    </AppLayout>
  )
}
